import React from 'react'
import {Icon} from '@chakra-ui/react'

const TouchIcon = (props) => {
    return (
        <Icon viewBox="0 0 14 14" fill="none" {...props}>
            <path
                d="M3.71854 12.25L2.33386 9.95312C2.1911 9.70205 2.15346 9.40469 2.22913 9.12596C2.3048 8.84723 2.48766 8.60974 2.73778 8.46532C2.98791 8.32091 3.28501 8.28129 3.56423 8.35512C3.84346 8.42894 4.08216 8.61021 4.22823 8.85938L5.24979 10.5V4.59375C5.24979 4.30367 5.36503 4.02547 5.57014 3.82035C5.77526 3.61523 6.05346 3.5 6.34354 3.5C6.63362 3.5 6.91182 3.61523 7.11694 3.82035C7.32206 4.02547 7.43729 4.30367 7.43729 4.59375V7.65625C7.43729 7.36617 7.55253 7.08797 7.75765 6.88285C7.96276 6.67773 8.24096 6.5625 8.53104 6.5625C8.82112 6.5625 9.09932 6.67773 9.30444 6.88285C9.50956 7.08797 9.62479 7.36617 9.62479 7.65625V8.53125C9.62479 8.24117 9.74003 7.96297 9.94515 7.75785C10.1503 7.55273 10.4285 7.4375 10.7185 7.4375C11.0086 7.4375 11.2868 7.55273 11.4919 7.75785C11.6971 7.96297 11.8123 8.24117 11.8123 8.53125V10.5C11.8123 11.2569 11.7166 11.8672 11.5935 12.25"
                stroke="#13183A"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3.0625 4.59375C3.0625 3.72351 3.4082 2.88891 4.02356 2.27356C4.63891 1.6582 5.47351 1.3125 6.34375 1.3125C7.21399 1.3125 8.04859 1.6582 8.66394 2.27356C9.2793 2.88891 9.625 3.72351 9.625 4.59375"
                stroke="#B2B1B4"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Icon>
    )
}

export default TouchIcon
